import { useQuery } from "@apollo/client";
import { ITermsResponse } from "./terms.interface";
import { TERMS } from "./terms.query";

export const useTerms = () => {
  const { loading, data } = useQuery<{ getTerms: ITermsResponse }>(TERMS);

  return {
    loading,
    termsData: data?.getTerms,
  };
};
